<template>
  <div class="ck-help">
    <div class="ck-help-menu">
      <div style="margin:10px">
        <el-input
          placeholder="请输入内容"
          v-model="searchFile" >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="ck-help-menu_title flex-center">
        <img src="../../assets/logo.png"/>
      </div>
      <el-tree
        ref="tree"
        :data="dataList"
        node-key="id"
        :expand-on-click-node="false"
        :current-node-key="currentNodeKey"
        :default-expanded-keys="[currentNodeKey]"
        :props="defaultProps"
        @node-click="function(avg){handleNodeClick(avg.id)}">
      </el-tree>
    </div>
    <div v-if="searchFile" class="ck-help-content">
      <h2 style="color: #2674BA;margin:40px 0">"{{searchFile}}"有{{mSearchHtml.length}}条搜索结果</h2>
      <ul style="width:860px;list-style-type:none;padding-top:20px">
        <li v-for="item in mSearchHtml" style="text-align: left;">
          <a style="display:inline-block;cursor:pointer;color:#4a5de4;font-size: 20px;font-weight: bold"
             @click="function(){currentNodeKey=item.catalogId;$refs.tree.setCurrentKey(item.catalogId);handleNodeClick(item.catalogId)}">
            {{item.title}}
          </a>
          <p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">
            {{item.noHtmlStr}}
          </p>
        </li>
      </ul>
    </div>
    <div v-else class="ck-help-content" v-loading="!isFinish">
      <div class="header">
        <div style="text-align:left;max-width:800px;padding:10px 0">
          {{mHtml.title}}
        </div>
      </div>
      <div style="text-align:-webkit-center;">
        <div v-html="mHtml.content" style="max-width:800px;font-size:14px"></div>
      </div>
      <div style="text-align:-webkit-center;">
        <div v-html="mFoot" style="max-width:800px;font-size:14px"></div>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
    export default {
      name: 'help',
      data() {
        return {
          searchFile: '',
          dataList: [],
          currentNodeKey:'1',
          defaultProps: {
            children: 'children',
            label: 'label'
          },
          isFinish:false,
          mHtml:{title:'',content:''},
          mFoot:'',
          mSearchHtml:[],
          timer:'',
        }
      },
      watch:{
        searchFile:function(avg){
          if(avg){
            if(this.timer){
              clearTimeout(this.timer)
            }
            this.timer = setTimeout(()=>{
              this.inputChange(avg)
            },500)
          }else{
            this.mSearchHtml = []
          }
        }
      },
      mounted(){
        this.init()
      },
      methods: {
        init(){
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/manual/get_all_open_manual',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            this.isFinish = true;
            this.dataList = res.data.data.map((item)=>{
              let child = item.secManual.map((itemChild)=>{
                return {
                  id:itemChild.id+'',
                  label: itemChild.catalogName,
                }
              })
              return {
                id:item.id+'',
                label: item.catalogName,
                children: child
              }
            })
          }).then(()=>{
            this.currentNodeKey = this.dataList[0].id+''
            this.$refs.tree.setCurrentKey(15)
            this.handleNodeClick(this.dataList[0].id)
          })
          this.get_by_id()
        },
        handleNodeClick(id) {
          this.searchFile = ''
          axios({
            method: 'post',url:process.env.PUBLIC_URL+'/content/get_open_by_catalogId',timeout: 30000,
            data:qs.stringify({catalogId:id}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            if(res.data.code == 200){
              this.mHtml = {title:res.data.data&&res.data.data.title||'',content:res.data.data&&res.data.data.details||''}
            }else{
              // this.init()
            }
          })
        },
        get_by_id(){
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/siteManagement/get_by_id',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            this.mFoot = res.data.data.content
          })
        },
        inputChange(avg){
          if(avg){
            axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/content/search',
              data:qs.stringify({str:avg}),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }).then((res)=>{
              // this.mFoot = res.data.data.content
              if(res.data.code == 200){
                this.mSearchHtml = res.data.data
              }else{
                this.mSearchHtml = []
              }
            })
          }
        }
      }
    }
</script>

<style >
  .flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ck-help {
    height: 100%;
    display: flex;
  }
  .ck-help .ck-help-menu {
    width: 300px;
    height: 100%;
    background: #F2F2F2;
    color: #101010;
    overflow: auto;
  }
  .ck-help .ck-help-menu .ck-help-menu_title {
    height: 100px;
  }
  .ck-help .ck-help-menu .el-tree {
    background: transparent !important;
    color: #101010 !important;
  }
  .ck-help .ck-help-menu .el-tree .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .ck-help .ck-help-menu .el-tree .el-tree-node {
    padding-left: 10px;
  }
  .ck-help .ck-help-menu .el-tree .el-tree-node:focus > .el-tree-node__content {
    background: transparent !important;
    color: #101010 !important;
  }
  .ck-help .ck-help-menu .el-tree .is-current {
    background: transparent !important;
  }
  .ck-help .ck-help-menu .el-tree .is-current:focus > .el-tree-node__content {
    background: transparent !important;
    color: #4a5de4 !important;
  }
  .ck-help .ck-help-menu .el-tree .is-current > .el-tree-node__content {
    background: transparent !important;
    color: #4a5de4 !important;
  }
  .ck-help .ck-help-menu .el-tree .el-tree-node__content {
    padding: 10px 0;
    height: auto;
  }
  .ck-help .ck-help-menu .el-tree .el-tree-node__content:hover {
    background: transparent !important;
    color: #101010 !important;
  }
  .ck-help .ck-help-menu .el-tree .el-tree-node__content:hover span:last-child {
    text-decoration: underline;
    color: #4a5de4
  }
  .ck-help .ck-help-content {
    width: calc(100% - 200px);
    height: 100%;
    overflow: auto;
  }
  .ck-help .ck-help-content .header {
    text-align: -webkit-center;
    color: #4a5de4;
    font-size: 24px;
    font-weight: bold;
    border-bottom: 1px solid #d1d5cb;
  }

</style>



// WEBPACK FOOTER //
// src/components/document/help.vue